"use client";
import React, { useEffect, useRef } from "react";

const Modal3Js = ({
  isOpen,
  onClose,
  title,
  children,
  onSubmit,
  submitText = "Submit",
  cancelText = "Cancel",
  size = "lg",
}) => {
  const modalRef = useRef(null);
  const submitButtonRef = useRef(null);

  // Handle ESC key press
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen, onClose]);

  // Focus trap inside modal
  useEffect(() => {
    if (isOpen) {
      // Set focus to the submit button when modal opens
      submitButtonRef.current?.focus();

      // Prevent scrolling on the body when modal is open
      document.body.style.overflow = "hidden";
    } else {
      // Re-enable scrolling when modal closes
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  // Handle backdrop click
  const handleBackdropClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose();
    }
  };

  if (!isOpen) return null;

  // Size classes
  const sizeClasses = {
    sm: "max-w-md",
    md: "max-w-lg",
    lg: "max-w-2xl",
    xl: "max-w-4xl",
  };

  return (
    <div className="js-popins popins is-open">
      <span className="js-background background"></span>
      <canvas className="js-popins-confetti-canvas confetti-canvas"></canvas>
      <div data-num="34" className="js-popin popin popin-start card is-start has-close is-active" data-name="challenges">

        <div className="card-head">
          <h2 className="card-title">
            {title}
          </h2>

          <button className="js-close button is-gray has-icon-left close" onClick={onClose}>
            <span className="hover"></span>
            <span className="icon"><svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="2" y1="8.87868" x2="8.87868" y2="2" stroke="#FE6854" stroke-width="3" stroke-linecap="round"></line>
              <line x1="8.87868" y1="9" x2="2" y2="2.12132" stroke="#FE6854" stroke-width="3" stroke-linecap="round"></line>
            </svg>
            </span>
          </button>
        </div>

        <div className="card-body helper-text-align-center">

          {children}
        </div>

      </div></div>
  );
};

export default Modal3Js;
